import React from 'react';
import { FaHome } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { ReactComponent as PageNotFoundSVG } from '../../assets/pageNotFound.svg';
import { Button, Typography } from '../../designComponents';
import { flexCenter } from '../../style/reusableStyle';

const PageNotFoundStyled = styled.div`
  ${flexCenter(20)};
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background: #fff;

  & svg.not-found {
    height: 300px;
  }
`;

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <PageNotFoundStyled>
      <Typography variant="heading" strong>
        Page Not Found
      </Typography>
      <PageNotFoundSVG className="not-found" />
      <Button onClick={() => navigate('/')}>
        <FaHome />
        Go to Home
      </Button>
    </PageNotFoundStyled>
  );
};

export default PageNotFound;
